import { Share, X } from "lucide-react";
import { useState } from "react";

const DISMISS_KEY = "install-hint-dismissed";

function isIOS() {
	const ua = navigator.userAgent;
	// iPadOS récent se fait passer pour macOS → on le détecte via le tactile.
	return /iP(hone|od|ad)/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}

function isStandalone() {
	const nav = navigator as Navigator & { standalone?: boolean };
	return window.matchMedia("(display-mode: standalone)").matches || nav.standalone === true;
}

/**
 * Bandeau d'aide affiché uniquement aux visiteurs iOS dans Safari (app non
 * installée) : sur iOS, le Web Push exige que la PWA soit à l'écran d'accueil.
 */
export default function InstallHint() {
	const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === "1");

	if (dismissed || !isIOS() || isStandalone()) return null;

	return (
		<div className="fixed top-0 left-1/2 z-[1100] flex w-[600px] max-[600px]:w-screen -translate-x-1/2 items-center gap-2 border-b border-white/10 bg-popover/95 px-3 pb-2.5 pt-[calc(10px+env(safe-area-inset-top))] text-xs text-foreground backdrop-blur-md">
			<span className="flex-1">
				Pour activer les notifications, ajoute l'app à ton écran d'accueil :{" "}
				<span className="inline-flex items-center gap-0.5 font-semibold">
					Partager <Share className="inline size-3.5" />
				</span>{" "}
				→ Sur l'écran d'accueil.
			</span>
			<button
				type="button"
				aria-label="Fermer"
				onClick={() => {
					localStorage.setItem(DISMISS_KEY, "1");
					setDismissed(true);
				}}
				className="shrink-0 rounded-full p-1 hover:bg-white/10"
			>
				<X className="size-4" />
			</button>
		</div>
	);
}
